<!--
 * @Author: ken yang
 * @Date: 2022-09-02 12:46:05
 * @LastEditTime: 2022-12-09 15:40:38
 * @LastEditors: ken yang
 * @Description: 复制按钮
 * @FilePath: /uexch_admin/src/components/buttons/CopyToClip.vue
-->
<template>
  <Row class="CopyToClip " @click="onCopyToClip">
    <slot name="front" />
    <IconSvg name="icon-IconCopy_User" />
    <!-- <img :src="image" :style="{width: size+ 'px', height: size+ 'px'}"> -->
    <slot name="back" />
  </Row>
</template>

<script setup>
import Row from '@/layout/flex/Row.vue'
import copyToClipImage from '@/image/copyToClip.webp'
import copyToClipFillImage from '@/image/copyToClip-fill.webp'
const route = useRoute()

const props = defineProps({
  label: {
    default: ''
  },
  value: {
    default: ''
  },
  size: { default: 12 },
  type: { default: '' }
})

const image = $computed(() => {
  const map = {
    '': copyToClipImage,
    'fill': copyToClipFillImage,
  }
  return map[props.type]
})

const onCopyToClip = () => {
  copyToClip(props.value)
  ElMessage.success($t('alert.copied'))
}

</script>

<style lang="scss">
.CopyToClip {
  padding: 0px !important;
  // font-weight: bold;
  cursor: pointer;
}
</style>

